import React from 'react';

import { DropdownTrigger } from '@atlassian/entry-points/dropdown-trigger';

import { dropdownEntryPoint } from '../fixtures/dropdown-entry-point';
import { RelayWrapper } from '../utils/wrapper';

export default function DropdownTriggerBasic(): React.JSX.Element {
	return (
		<RelayWrapper>
			<DropdownTrigger
				entryPoint={dropdownEntryPoint}
				trigger="Page actions"
				menuLabel="Page actions"
				loadingText="Loading page actions"
				shouldRenderToParent
			/>
		</RelayWrapper>
	);
}
